import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Cell } from '@phishtool/ui';
import { StyledBannerWrapper, StyledBannerText, StyledBannerLink } from './styled';
const Banner = () => (_jsx(StyledBannerWrapper, { children: _jsx(Grid, { children: _jsx(Cell, { children: _jsxs(StyledBannerText, { children: ["Defend your mailboxes with PhishTool Enterprise.", ' ', _jsx(StyledBannerLink, Object.assign({ to: "/products/enterprise" }, { children: "Find out more" }))] }) }) }) }));
export default Banner;
